import { put, select } from 'redux-saga/effects';
import actions from '../../../../actions';
import * as selectors from '../../../../selectors';

export function* handleProjectUpdate(project, projectProfessions, boardId) {
  const { boardId: currentBoardId } = yield select(selectors.selectPath);
  const localProject = yield select(selectors.selectProjectById, project.id);
  yield put(actions.handleProjectUpdate(project, projectProfessions));

  // Always refresh board when password requirements might have changed
  // We check if password was removed (project is now public or has no password)
  const requiresPassword = project.hasPassword === true || !project.isPublic;

  if (boardId && !requiresPassword) {
    // Password requirement was likely removed - refresh the board to load all content
    yield put(actions.handleBoardRefresh(boardId));
  } else if (boardId === currentBoardId && localProject?.isPublic !== project.isPublic) {
    // Handle public status changes as before
    yield put(actions.handleBoardRefresh(boardId));
  }
}
